// Service Icon List - Available icons for service selection
export const SERVICE_ICON_LIST = [
// Dashboard & Diagnostics
{
  name: 'fa-light-gauge',
  label: 'Dashboard/Diagnostics',
  category: 'Diagnostics'
}, {
  name: 'fa-regular-gauge',
  label: 'Dashboard/Diagnostics (Regular)',
  category: 'Diagnostics'
}, {
  name: 'fa-duotone-gauge',
  label: 'Dashboard/Diagnostics (Duotone)',
  category: 'Diagnostics'
},
// General Automotive
{
  name: 'fa-light-car',
  label: 'General Auto Service',
  category: 'General'
}, {
  name: 'fa-regular-car',
  label: 'General Auto Service (Regular)',
  category: 'General'
}, {
  name: 'fa-duotone-car',
  label: 'General Auto Service (Duotone)',
  category: 'General'
},
// Cooling System
{
  name: 'fa-light-water-temperature',
  label: 'Coolant/Temperature',
  category: 'Cooling'
}, {
  name: 'fa-regular-water-temperature',
  label: 'Coolant/Temperature (Regular)',
  category: 'Cooling'
}, {
  name: 'fa-duotone-water-temperature',
  label: 'Coolant/Temperature (Duotone)',
  category: 'Cooling'
}, {
  name: 'fa-light-tank-water',
  label: 'Coolant Tank',
  category: 'Cooling'
}, {
  name: 'fa-regular-tank-water',
  label: 'Coolant Tank (Regular)',
  category: 'Cooling'
}, {
  name: 'fa-duotone-tank-water',
  label: 'Coolant Tank (Duotone)',
  category: 'Cooling'
},
// Transmission
{
  name: 'fa-light-transmission',
  label: 'Transmission Service',
  category: 'Transmission'
}, {
  name: 'fa-regular-transmission',
  label: 'Transmission Service (Regular)',
  category: 'Transmission'
}, {
  name: 'fa-duotone-transmission',
  label: 'Transmission Service (Duotone)',
  category: 'Transmission'
},
// Tires
{
  name: 'fa-light-tire',
  label: 'Tire Service',
  category: 'Tires'
}, {
  name: 'fa-regular-tire',
  label: 'Tire Service (Regular)',
  category: 'Tires'
}, {
  name: 'fa-duotone-tire',
  label: 'Tire Service (Duotone)',
  category: 'Tires'
}, {
  name: 'fa-light-tire-flat',
  label: 'Flat Tire Repair',
  category: 'Tires'
}, {
  name: 'fa-regular-tire-flat',
  label: 'Flat Tire Repair (Regular)',
  category: 'Tires'
}, {
  name: 'fa-duotone-tire-flat',
  label: 'Flat Tire Repair (Duotone)',
  category: 'Tires'
}, {
  name: 'fa-light-tire-pressure-warning',
  label: 'Tire Pressure',
  category: 'Tires'
}, {
  name: 'fa-regular-tire-pressure-warning',
  label: 'Tire Pressure (Regular)',
  category: 'Tires'
}, {
  name: 'fa-duotone-tire-pressure-warning',
  label: 'Tire Pressure (Duotone)',
  category: 'Tires'
},
// Steering
{
  name: 'fa-light-steering-wheel',
  label: 'Steering Service',
  category: 'Steering'
}, {
  name: 'fa-regular-steering-wheel',
  label: 'Steering Service (Regular)',
  category: 'Steering'
}, {
  name: 'fa-duotone-steering-wheel',
  label: 'Steering Service (Duotone)',
  category: 'Steering'
},
// Oil & Lubrication
{
  name: 'fa-light-oil-can',
  label: 'Oil Change',
  category: 'Oil'
}, {
  name: 'fa-regular-oil-can',
  label: 'Oil Change (Regular)',
  category: 'Oil'
}, {
  name: 'fa-duotone-oil-can',
  label: 'Oil Change (Duotone)',
  category: 'Oil'
}, {
  name: 'fa-light-oil-can-drip',
  label: 'Oil Service',
  category: 'Oil'
}, {
  name: 'fa-regular-oil-can-drip',
  label: 'Oil Service (Regular)',
  category: 'Oil'
}, {
  name: 'fa-duotone-oil-can-drip',
  label: 'Oil Service (Duotone)',
  category: 'Oil'
}, {
  name: 'fa-light-oil-temperature',
  label: 'Oil Temperature',
  category: 'Oil'
}, {
  name: 'fa-regular-oil-temperature',
  label: 'Oil Temperature (Regular)',
  category: 'Oil'
}, {
  name: 'fa-duotone-oil-temperature',
  label: 'Oil Temperature (Duotone)',
  category: 'Oil'
},
// Repair & Maintenance
{
  name: 'fa-light-car-wrench',
  label: 'General Repair',
  category: 'Repair'
}, {
  name: 'fa-regular-car-wrench',
  label: 'General Repair (Regular)',
  category: 'Repair'
}, {
  name: 'fa-duotone-car-wrench',
  label: 'General Repair (Duotone)',
  category: 'Repair'
},
// Warning & Diagnostics
{
  name: 'fa-light-engine-warning',
  label: 'Engine Issues',
  category: 'Warnings'
}, {
  name: 'fa-regular-engine-warning',
  label: 'Engine Issues (Regular)',
  category: 'Warnings'
}, {
  name: 'fa-duotone-engine-warning',
  label: 'Engine Issues (Duotone)',
  category: 'Warnings'
}, {
  name: 'fa-light-brake-warning',
  label: 'Brake Service',
  category: 'Warnings'
}, {
  name: 'fa-regular-brake-warning',
  label: 'Brake Service (Regular)',
  category: 'Warnings'
}, {
  name: 'fa-duotone-brake-warning',
  label: 'Brake Service (Duotone)',
  category: 'Warnings'
},
// Battery & Electrical
{
  name: 'fa-light-car-battery',
  label: 'Battery Service',
  category: 'Electrical'
}, {
  name: 'fa-regular-car-battery',
  label: 'Battery Service (Regular)',
  category: 'Electrical'
}, {
  name: 'fa-duotone-car-battery',
  label: 'Battery Service (Duotone)',
  category: 'Electrical'
},
// Facility
{
  name: 'fa-light-garage-car',
  label: 'Shop/Garage Service',
  category: 'Facility'
}, {
  name: 'fa-regular-garage-car',
  label: 'Shop/Garage Service (Regular)',
  category: 'Facility'
}, {
  name: 'fa-duotone-garage-car',
  label: 'Shop/Garage Service (Duotone)',
  category: 'Facility'
},
// Additional existing icons that work well for services
{
  name: 'fa-solid-toolbox',
  label: 'General Tools',
  category: 'General'
}, {
  name: 'fa-solid-certificate',
  label: 'Inspection/Certification',
  category: 'Certification'
}, {
  name: 'fa-regular-cog',
  label: 'Mechanical Work',
  category: 'Mechanical'
}, {
  name: 'custom-tune',
  label: 'Tune-up',
  category: 'Maintenance'
}];

// Default icon for services without an icon
export const DEFAULT_SERVICE_ICON = 'fa-light-car-wrench';

// Get icon by name
export const getServiceIcon = iconName => {
  return SERVICE_ICON_LIST.find(icon => icon.name === iconName) || {
    name: DEFAULT_SERVICE_ICON,
    label: 'General Service',
    category: 'General'
  };
};

// Group icons by category
export const getServiceIconsByCategory = () => {
  return SERVICE_ICON_LIST.reduce((acc, icon) => {
    if (!acc[icon.category]) {
      acc[icon.category] = [];
    }
    acc[icon.category].push(icon);
    return acc;
  }, {});
};